export default class Layouts {
    constructor() {


        this.pileLayout0 = {
            "name": "pileLayout0",
            "tablePosition": "player1",
            "background": { x: 0, y: 0, width: 800, height: 500, left: 0, widthPercent: 100, heightPercent: 100 },
            "deck": { x: 200, y: 350, offsetX: 0.5, offsetY: -0.5, width: 120, height: 180, showfront: true },
            "draw": { x: 200, y: 350, offsetX: 0.5, offsetY: -0.5, width: 120, height: 180, showfront: true },
            "discard": { x: 350, y: 350, offsetX: 1, offsetY: -0.5, width: 120, height: 180 },
            "hand0": { x: 0, y: 680, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },
            "hand1": { x: 0, y: 90, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "center", randomZOrder: true, showfront: true },
            //"hand1": { x: 0, y: 90, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds", randomZOrder: false, showfront: false },

            "stage": { x: 50, y: 773 },

            "instructions0": { x: 250, y: 520 },
            "instructions1": { x: 250, y: -300 },

            "deadwoodCount0": { x: 390, y: 560 },
            "deadwoodCount1": { x: -1390, y: 190 },

            "scoreCount0": { x: 60, y: 560 },
            "scoreCount1": { x: 60, y: 190 },

            "pass0": { x: 250 - (220 / 2), y: 455 },
            "pass1": { x: 250 - (220 / 2), y: -300 },

            "btnEndRound": { x: 250 - (220 / 2), y: 455 },
            "btnNext": { x: 250 - (220 / 2), y: 455 },

            "knock0": { x: 250 - (220 / 2), y: 455 },
            "knock1": { x: 250 - (220 / 2), y: -300 },

            "handIndicator0": { x: 0, y: 680 - (180 / 2) },
            "handIndicator1": { x: 0, y: 90 - (180 / 2) },

            "drawIndicator0": { x: 200 - (120 / 2), y: 350 - (180 / 2) },
            "drawIndicator1": { x: 200 - (120 / 2), y: 350 - (180 / 2) },

            "discardIndicator0": { x: 350 - (120 / 2), y: 350 - (180 / 2) },
            "discardIndicator1": { x: 350 - (120 / 2), y: 350 - (180 / 2) },



            "chatBubble0": { x: 180, y: 520 },
            "chatBubble1": { x: 180, y: 190 },



            "profile0": { x: -100, y: 545 },
            "profile1": { x: -100, y: 85 },

            "roundSummary": { x: 0, y: 185, visible: false },

            "gameOver": { x: 50, y: 300, visible: false },
        };
        this.pileLayout0_scoring = {
            "name": "pileLayout0_scoring",
            "tablePosition": "player1",
            "background": { x: 0, y: 0, width: 800, height: 500 },

            "draw": { x: -200, y: 350, offsetX: 0.5, offsetY: -0.5, width: 120, height: 180, showfront: true },
            "discard": { x: -350, y: 350, offsetX: 1, offsetY: -0.5, width: 120, height: 180 },
            "hand0": { x: 0, y: 680, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },
            "hand1": { x: 0, y: 90, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },

            "stage": { x: 50, y: 773 },

            "instructions0": { x: 250, y: 450 },
            "instructions1": { x: 250, y: -210 },

            "deadwoodCount0": { x: 390, y: 560 },
            "deadwoodCount1": { x: 390, y: 190 },

            "scoreCount0": { x: 60, y: 560 },
            "scoreCount1": { x: 60, y: 190 },


            "pass0": { x: 250 - (220 / 2), y: 455 },
            "pass1": { x: 250 - (220 / 2), y: 180 },

            "btnEndRound": { x: 250 - (220 / 2), y: 500 },
            "btnNext": { x: 250 - (220 / 2), y: 350, visible: false },

            "knock0": { x: 250 - (220 / 2), y: 455 },
            "knock1": { x: -1000 + 250 - (220 / 2), y: 180, visible: false },

            "handIndicator0": { x: 0, y: 680 - (180 / 2) },
            "handIndicator1": { x: 0, y: 90 - (180 / 2) },

            "drawIndicator0": { x: 200 - (120 / 2), y: 350 - (180 / 2) },
            "drawIndicator1": { x: 200 - (120 / 2), y: 350 - (180 / 2) },

            "discardIndicator0": { x: 350 - (120 / 2), y: 350 - (180 / 2) },
            "discardIndicator1": { x: 350 - (120 / 2), y: 350 - (180 / 2) },



            "chatBubble0": { x: 180, y: 520 },
            "chatBubble1": { x: 180, y: 190 },

            "scoreDetails": { x: 250, y: 385 },

            "profile0": { x: -100, y: 545 },
            "profile1": { x: -100, y: 85 },

            "roundSummary": { x: 0, y: 185 },

            "gameOver": { x: 50, y: 300, visible: false },
        };
        this.pileLayout0_gameover = {
            "name": "pileLayout0_gameover",
            "tablePosition": "player1",
            "background": { x: 0, y: 0, width: 800, height: 500 },

            "draw": { x: -200, y: 350, offsetX: 0.5, offsetY: -0.5, width: 120, height: 180, showfront: true },
            "discard": { x: -350, y: 350, offsetX: 1, offsetY: -0.5, width: 120, height: 180 },
            "hand0": { x: 0, y: 680, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },
            "hand1": { x: 0, y: 90, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },

            "stage": { x: 50, y: 773 },

            "instructions0": { x: 250, y: 450 },
            "instructions1": { x: 250, y: -210 },

            "deadwoodCount0": { x: 390, y: 560 },
            "deadwoodCount1": { x: 390, y: 190 },

            "scoreCount0": { x: 60, y: 560 },
            "scoreCount1": { x: 60, y: 190 },


            "pass0": { x: 250 - (220 / 2), y: 455 },
            "pass1": { x: 250 - (220 / 2), y: 180 },

            "btnEndRound": { x: 250 - (220 / 2), y: 500 },
            "btnNext": { x: 250 - (220 / 2), y: 350, visible: false },

            "knock0": { x: 250 - (220 / 2), y: 455 },
            "knock1": { x: 250 - (220 / 2), y: 180 },

            "handIndicator0": { x: 0, y: 680 - (180 / 2) },
            "handIndicator1": { x: 0, y: 90 - (180 / 2) },

            "drawIndicator0": { x: 200 - (120 / 2), y: 350 - (180 / 2) },
            "drawIndicator1": { x: 200 - (120 / 2), y: 350 - (180 / 2) },

            "discardIndicator0": { x: 350 - (120 / 2), y: 350 - (180 / 2) },
            "discardIndicator1": { x: 350 - (120 / 2), y: 350 - (180 / 2) },



            "chatBubble0": { x: 180, y: 520 },
            "chatBubble1": { x: 180, y: 190 },

            "scoreDetails": { x: 250, y: 385 },

            "profile0": { x: -100, y: 545 },
            "profile1": { x: -100, y: 85 },

            "roundSummary": { x: 150, y: 185 },

            "gameOver": { x: 50, y: 300, visible: false },
        };

        this.pileLayout1 = {
            "tablePosition": "player1",
            "background": { x: 0, y: 0, width: 800, height: 500 },

            "draw": { x: 200, y: 350, offsetX: 0.5, offsetY: -0.5, width: 120, height: 180, showfront: true },
            "discard": { x: 350, y: 350, offsetX: 1, offsetY: -0.5, width: 120, height: 180 },
            "hand0": { x: 0, y: 680, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "center", randomZOrder: true, showfront: true },
            "hand1": { x: 0, y: 90, pileWidth: 500, offsetX: 45, offsetY: 0, width: 120, height: 180, style: "melds" },

            "instructions0": { x: 250, y: 550 },
            "instructions1": { x: 250, y: 210 },

            "deadwoodCount0": { x: 250, y: 773 },
            "deadwoodCount1": { x: 250, y: 190 },

            "pass0": { x: 250 - (220 / 2), y: 455 },
            "pass1": { x: 250 - (220 / 2), y: 180 },

            "knock0": { x: 250 - (220 / 2), y: 455 },
            "knock1": { x: 250 - (220 / 2), y: 180 },

            "handIndicator0": { x: 0, y: 680 - (180 / 2) },
            "handIndicator1": { x: 0, y: 90 - (180 / 2) },

            "drawIndicator0": { x: 200 - (120 / 2), y: 350 - (180 / 2) },
            "drawIndicator1": { x: 200 - (120 / 2), y: 350 - (180 / 2) },

            "discardIndicator0": { x: 350 - (120 / 2), y: 350 - (180 / 2) },
            "discardIndicator1": { x: 350 - (120 / 2), y: 350 - (180 / 2) },

            "profile1": { x: 80, y: 350 },
            "profile2": { x: 80, y: 10 },
        };
    }
}